import paginator from '@/helpers/paginator';

export default {
  allAddons: async (data = null) => await paginator.grabAllPages($nuxt.$api.host + '/addon/', {}, data),

  all: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/addon/', data),
  allSubscriptions: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/addon-subscriptions', data),
  subscribe: (data) => $nuxt.$axios.post($nuxt.$api.host + '/subscribe', data),
  singleSubscription: (uuid, data = null) => $nuxt.$axios.get($nuxt.$api.host + '/addon-subscriptions/' + uuid, data),
  updateSubscription: (uuid, data) => $nuxt.$axios.put($nuxt.$api.host + '/addon-subscriptions/' + uuid, data),
  unsubscribe: (uuid) => $nuxt.$axios.delete($nuxt.$api.host + '/addon-subscriptions/' + uuid),
  enableSubscription: (uuid) => $nuxt.$axios.post($nuxt.$api.host + '/addon-subscriptions/' + uuid + '/enable'),
  confirmPayment: (uuid) => $nuxt.$axios.post($nuxt.$api.host + '/addon-subscriptions/' + uuid + '/confirm-payment'),
  disableSubscription: (uuid) => $nuxt.$axios.post($nuxt.$api.host + '/addon-subscriptions/' + uuid + '/disable'),
  addonCategories: () => $nuxt.$axios.get($nuxt.$api.host + '/static/addon-categories/'),

  secclNodes: (addon) => $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/nodes`),
  secclSearchAssets: (addon, data) =>
    $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/search-assets`, { params: data }),
  secclSchemaProducts: (addon) => $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/schema-products`),
  secclClient: (addon, account_uuid) =>
    $nuxt.$axios.get($nuxt.$api.host + `/addons/seccl/${addon}/client/${account_uuid}`),

  saveMapping: (addon, data) => $nuxt.$axios.post($nuxt.$api.host + `/addons/seccl/${addon}/associate-node`, data),
  getPlatformModels: (provider, data) => $nuxt.$axios.get($nuxt.$api.host + '/platform/' + provider + '/models', data),
  getPlatformDetail: (provider) => $nuxt.$axios.get($nuxt.$api.host + `/platform/${provider}`),

  getBeIQClient: (clientUuid) => $nuxt.$axios.get($nuxt.$api.host + `/addons/be-iq/client/` + clientUuid),
  sendBeIQInvitation: (data) => $nuxt.$axios.post($nuxt.$api.host + `/addons/be-iq/profiler/invite`, data),
  getBeIQToken: () => $nuxt.$axios.get($nuxt.$api.host + `/addons/be-iq/token`),

  submitSmartSearch: (client_uuid, data) =>
    $nuxt.$axios.post($nuxt.$api.host + `/addons/smartsearch/ukaml/${client_uuid}/run`, data),

  sendTransactAccount: (data) => $nuxt.$axios.post($nuxt.$api.host + `/addons/transact/account-opening`, data),

  // Mortgage Brain Addon
  canUseMortgageBrainAddon: () => $nuxt.$axios.get($nuxt.$api.host + '/addons/mortgagebrain/ready'),
  submitMortgageBrainSearch: (data) =>
    $nuxt.$axios.post($nuxt.$api.host + `/addons/mortgagebrain/mortgage-search`, data),
};
